// Desc: generic state for for pcb fabrication
import { START } from 'pu-data/QuoteSteps';
import defaultParameters from './defaultParameters';
import defaultParametersCustomer from './defaultParametersCustomer';
import defaultSuppliers from './defaultSuppliers';
import defaultQuote from './defaultQuote';
import defaultVendorCombined from './defaultVendorCombined';
import { USA_QUICKTURN_ID } from './productVariants';

const state = {
  loading: false,
  parameters: defaultParameters,
  parametersCustomer: defaultParametersCustomer,
  parametersBestPrice: defaultParametersCustomer,
  parametersChanged: false,
  boardConfirmSpecs: false,
  suppliers: defaultSuppliers,
  quoteStep: START,
  quote: defaultQuote,
  usGroups: [],
  usCombined: defaultVendorCombined,
  currentVariant: USA_QUICKTURN_ID,
  destroy: false,
  lineItemId: null,
  quantitiesChanged: false,
};

export default state;
